module.exports = __webpack_public_path__ + "img/img_judicial.2c470bde.jpg";